import { CHANGE_SECTION } from '@/store/actions/sections';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';

const initialState = {
    items: [
        {
            key: 'rides',
            stateKey: 'rides',
            columns: 3
        },
        {
            key: 'dealers',
            stateKey: 'dealers',
            columns: 2
        },
        {
            key: 'events',
            stateKey: 'events',
            columns: 2
        }
    ],
    active: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_SECTION: {
            const { key } = action.data;

            const active = state.items.findIndex(
                (section) => section.key === key
            );

            return { ...state, active: Math.max(active, 0) };
        }

        case AUTH_INVALIDATE:
        default:
            return state;
    }
};
